import { DataTestId, TextKey } from '@mews-distributor/common';
import { omitFalsyValues } from '@mews/fp';
import { LocalizedText } from '@mews/framework';
import { Checkbox } from '@optimus-web/core';
import { getChainName } from '../../../../modules/entities/chains/selectors';
import { getEnterpriseChainId, getEnterpriseName } from '../../../../modules/entities/enterprises/selectors';
import { localizeProperty } from '../../../../modules/globalization/selectors';
import { useAppSelector } from '../../../../utils/redux';

const id = 'marketing-emails-checkbox';

interface MarketingEmailsProps {
    enterpriseId: string;
    checked: boolean | undefined;
    onChange: (event: React.SyntheticEvent<HTMLElement>, checked: boolean) => void;
}

export const MarketingEmails = ({ checked, onChange, enterpriseId }: MarketingEmailsProps) => {
    const enterpriseName = useAppSelector((state) => {
        const name = getEnterpriseName(state, { enterpriseId });
        return localizeProperty(state, { property: name });
    });
    const chainName = useAppSelector((state) => {
        const chainId = getEnterpriseChainId(state, { enterpriseId });
        return chainId != null ? getChainName(state, { chainId }) : null;
    });

    return (
        <Checkbox
            checked={checked}
            onChange={onChange}
            id={id}
            name={id}
            data-test-id={DataTestId.MarketingEmailsCheckbox}
        >
            {enterpriseName === chainName ? (
                <LocalizedText
                    textKey={TextKey.SendMarketingEmailsTemplate}
                    substitutes={omitFalsyValues({ enterpriseName })}
                />
            ) : (
                <LocalizedText
                    textKey={TextKey.SendMarketingEmailsTemplateEnterpriseAndChain}
                    substitutes={omitFalsyValues({ enterpriseName, chainName })}
                />
            )}
        </Checkbox>
    );
};
